import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/shipments',
  component: Layout,
  name: 'shipments',
  redirect: '/shipments/index',
  children: [{
    path: '/shipments/index',
    component: () => import('@/views/shipments/index'),
    name: 'shipments.index',
    meta: {
      title: i18n.t(`message.shipment`),
    }
  }, ]
}

export default paymentType